import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import useTextLocalizer from '../../locale/useTextLocalizer';
import bundle from './NovaComponents-HelpPopup-gui-icu.properties';
const useHelpTextLocalizer = createUseTextLocalizer(bundle);
export const useHelpPopupA11yInfo = props => {
  const localize = useHelpTextLocalizer();
  const localizeHelpContent = useTextLocalizer(props.library);

  // Localize returns key passed to it if no content is found
  // If that happens, or the content found is blank, set default tooltip and aria text
  const localizedTooltip = localizeHelpContent(`${props.contentKey}.help.tip.txt`);
  const buttonTooltip = localizedTooltip && localizedTooltip !== `${props.library}.${props.contentKey}.help.tip.txt` ? localizedTooltip : localize('default.tooltip.msg');
  const ariaText = localizeHelpContent(`${props.contentKey}.help.aria.txt`);
  let buttonAriaLabel = ariaText && ariaText !== `${props.library}.${props.contentKey}.help.aria.txt` ? ariaText : localize('default.tooltip.msg');
  buttonAriaLabel = props.additionalAriaText ? `${props.additionalAriaText}, ${buttonAriaLabel}` : buttonAriaLabel;
  const dialogAriaLabel = localize('dialog.content.aria');
  return {
    buttonAriaLabel,
    buttonTooltip,
    dialogAriaLabel
  };
};
//# sourceMappingURL=useHelpPopupA11yInfo.js.map